<template>
  <div :class="{ row: isPrint, horizontal: isHorizontal }"><slot /></div>
</template>

<script>
export default {
  name: "PrintRow",
  props: {
    isHorizontal: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>
